import { createSelector } from 'reselect';

const getCurrentUser = state => state.applicationContext.applicationContext.user;
const getClient = state => state.applicationContext.applicationContext.client;

export const selectCurrentUser = createSelector(getCurrentUser, user => { return user });
export const selectClient = createSelector(getClient, client => { return client });